module.exports = __webpack_public_path__ + "img/icon_tip.03c41466.svg";